import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { AuthFacade } from '../facades/auth.facade';
import { toObservable } from '@angular/core/rxjs-interop';
import { filter, map } from 'rxjs';

/**
 * Gate for the `/admin` (super-admin) shell. Mirrors `adminGuard`, but for the
 * platform-admin role. Defers the decision until auth has resolved.
 */
export const superAdminGuard: CanActivateFn = () => {
  const authFacade = inject(AuthFacade);
  const router = inject(Router);

  return toObservable(authFacade.isLoading).pipe(
    filter(isLoading => !isLoading),
    map(() => {
      if (authFacade.isSuperAdmin()) {
        return true;
      }

      if (!authFacade.isAuthenticated()) {
        return router.createUrlTree(['/auth/login']);
      }

      // A signed-in non-super-admin: send them to their own shell.
      return router.createUrlTree([authFacade.isTeacher() ? '/teacher/home' : '/student/home']);
    }),
  );
};
